import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface AdministrativeUnitState {
  listProvinces: IProvince[];
  listDistricts: IDistrict[];
  listWards: IWard[];
  setListProvinces: (provinces: IProvince[]) => void;
  setListDistricts: (districts: IDistrict[]) => void;
  setListWards: (wards: IWard[]) => void;
}

// const useAdministrativeUnitStore = create<AdministrativeUnitState>((set) => ({
//   listProvinces: [],
//   listDistricts: [],
//   listWards: [],
//   setListProvinces: (provinces: IProvince[]) =>
//     set({ listProvinces: provinces }),
//   setListDistricts: (districts: IDistrict[]) =>
//     set({ listDistricts: districts }),
//   setListWards: (wards: IWard[]) => set({ listWards: wards })
// }));

const useAdministrativeUnitStore = create<AdministrativeUnitState>()(
  persist(
    (set) => ({
      listProvinces: [],
      listDistricts: [],
      listWards: [],

      setListProvinces: (provinces: IProvince[]) =>
        set({ listProvinces: provinces }),
      setListDistricts: (districts: IDistrict[]) =>
        set({ listDistricts: districts }),
      setListWards: (wards: IWard[]) => set({ listWards: wards })
    }),
    {
      name: "administrative-unit-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        listProvinces: state.listProvinces,
        listDistricts: state.listDistricts,
        listWards: state.listWards
      })
    }
  )
);

export default useAdministrativeUnitStore;
